import { HttpContextToken } from '@angular/common/http';

/** Request-local Account tenant override; never changes the selected business workspace. */
export const HTTP_WORKSPACE_TENANT_ID = new HttpContextToken<number | null>(() => null);
